function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#6e95ff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.89,9.14c0,.45-.37,.81-.81,.81h-1.88v1.88c0,.45-.36,.81-.81,.81s-.81-.36-.81-.81v-1.88h-1.88c-.44,0-.81-.36-.81-.81s.37-.81,.81-.81h1.88v-1.88c0-.44,.37-.81,.81-.81s.81,.37,.81,.81v1.88h1.88c.44,0,.81,.37,.81,.81Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.28,
    cy: 7.53,
    r: 1.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.56,3.29h-2.56c-2.5,0-3.62,1.23-3.62,3.98v2.86c0,2.72,1.15,3.98,3.62,3.98h2.56c2.5,0,3.62-1.23,3.62-3.98v-2.86c0-2.75-1.12-3.98-3.62-3.98Zm2.32,6.84c0,1.29-.25,1.98-.75,2.33,.05-.08,.07-.18,.06-.28-.02-.23-.07-.45-.17-.66-.1-.24-.24-.46-.42-.65-.04-.05-.09-.1-.15-.15-.04-.05-.1-.09-.15-.13-.05-.05-.1-.09-.16-.12-.31-.23-.68-.39-1.08-.48-.06-.02-.13-.04-.2-.04-.09-.02-.2-.04-.3-.04-.09-.01-.18-.02-.28-.02s-.19,.01-.29,.02c-.82,.06-1.55,.43-2.03,.96-.05,.04-.09,.09-.13,.15-.12,.15-.22,.32-.3,.5-.09,.21-.14,.43-.16,.66-.01,.09,0,.19,.05,.27-.49-.35-.74-1.04-.74-2.32v-2.86c0-2.27,.78-2.68,2.32-2.68h2.56c1.54,0,2.32,.41,2.32,2.68v2.86Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCreate);
export default __webpack_public_path__ + "static/media/profile_create.3f13be3c600269026512be091e6e6405.svg";
export { ForwardRef as ReactComponent };